<div (click)="handleClick()">
  <span class="text">{{ text }}</span>
  <app-opin-icon [icon]="icon" class="text"></app-opin-icon>
</div>
